'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _layout = require('../layout');

exports["default"] = _layout.Col;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/antd/lib/col/index.js
 ** module id = 1083
 ** module chunks = 0
 **/